"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useUser } from "@/lib/context/user-context";
import { AuthLoadingFallback } from "./AuthLoadingFallback";

interface AuthGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function AuthGuard({ children, fallback }: AuthGuardProps) {
  const { user, isLoading } = useUser();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      if (!user) {
        const currentPath = window.location.pathname + window.location.search;
        localStorage.setItem("auth_redirect_url", currentPath);
        router.push(`/login?redirectTo=${encodeURIComponent(currentPath)}`);
      }
    }, 50);

    return () => window.clearTimeout(timeoutId);
  }, [isLoading, router, user]);

  if (isLoading) {
    return fallback ?? <AuthLoadingFallback />;
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
}
